import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PageBase, UIService } from 't4core';
import { AssetCondition, AssetInfo, InventoryAssetInfo, ServiceGuyInfo } from "../../../../../projects/t4core/src/public-api";
import { Console } from "console";
import { FormControl, FormGroup } from "@angular/forms";
import { T4DatatableWidget } from "../../../../t4common";

@Component({
  styleUrls: ['./AssetsDashboard.component.css'],
  selector: 'AssetsDashboard',
  templateUrl: './AssetsDashboard.component.html',
})

export class AssetsDashboardComponent extends PageBase implements OnInit {

  @ViewChild("tblAssets", { static: false })
  private tblAssets: T4DatatableWidget;

  public Assets: AssetInfo[];
  public AssetsFilterd: AssetInfo[];
  public CopyAsset: AssetInfo[];
  public loading: boolean = false;

  public formGroup = new FormControl([]);

  public InventoryAssets: InventoryAssetInfo[]

  public action = false;
  public workingAssets: boolean = false;
  public onContract: boolean = false;

  public imageDirty: boolean = false;
  public showImportTracker: boolean = false;
  public files: string[] = [];
  public maxFiles = 10;
  @ViewChild("txtFile") private txtFile: ElementRef;
  constructor(el: ElementRef,
    private route: ActivatedRoute,
    private ui: UIService) {
    super(el, "AssetDashboard");

  }

  public async ngOnInit() {
    this.workingAssets = false;

    this.GetAssets();
  }

  private async GetAssets() {

    var token = this.UI.beginLoading("T4.Campaigns.campaign.msgsubassetInfo", "Loading assets", null);
    this.CopyAsset = await this.Api.get<AssetInfo[]>("Service/GetAssetsWithContractStatus");

    this.Assets = this.CopyAsset;

    this.action = true;
    this.UI.loaderCompleted(token);
  }

  public hasActiveContract(row): boolean {
      if (row.AssetTransactions) {
      return row.AssetTransactions.some(contract => !contract.EndDate || contract.EndDate > new Date());
    }

    return false;
  }



  public async ScrapAssets() {

    // Cancel if active agreement and inform user
    for (var contractAsset of this.tblAssets.selectedRows) {

      const hasContract = this.hasActiveContract(contractAsset);

      if (hasContract) {
        this.UI.alert("Turbo.Core.SetTranslation.ErrorMsgTitle", "Failed!", "Turbo.Core.SetTranslation.ErrorMsgActivContract", "One or more assets have an active contract");
        return;
      }
    }


    if (this.tblAssets.selectedRows)

      var confirmation = await this.UI.openDialog('T4.Service.TransferSummary', {
        width: "600px",
        data: { locks: this.tblAssets.selectedRows, mode: "Scrap" }
      });
     
    if (confirmation) {
      for (var contractAsset of this.tblAssets.selectedRows) {
        await this.Api.post<boolean>("/Service/ScrapAssets", null, { asset: contractAsset.Id });
      }
    }

    this.GetAssets();
  }



  public async TransferAssets() {


    // Cancel if active agreement and inform user
    for (var contractAsset of this.tblAssets.selectedRows) {

      if (contractAsset.ContextId == null)
        return;
      else {

        const hasContract = this.hasActiveContract(contractAsset);

        if (hasContract) {
          this.UI.alert("Turbo.Core.SetTranslation.ErrorMsgTitle", "Failed!", "Turbo.Core.SetTranslation.ErrorMsgActivContract", "One or more assets have an active contract");
          return;
        }
      }
    }

    var serviceguySelect = await this.UI.openDialog<ServiceGuyInfo>('T4.Service.selectServiceGuy', {
      width: "1000px",
      data: { locks: this.tblAssets.selectedRows }
    });

    console.log(serviceguySelect);

    if (serviceguySelect == null) return;


    for (var item of this.tblAssets.selectedRows) {
      await this.Api.post<boolean>("/Service/TransferAsset", null, { AssetId: item.Id, sgId: serviceguySelect.Id });
    }

    this.GetAssets();
  }

  public async CancelSubscriptions() {
    for (var item of this.tblAssets.selectedRows) {
      if (await this.Api.post<boolean>("/Service/DisconnectAsset", null, { AssetId: item.Id })) {
        item.AssetTransactions.filter(x => !x.EndDate).map(x => x.EndDate = new Date());
      }
    }

    this.GetAssets();
  }

  public filterAssets() {
      this.CopyAsset = this.Assets.filter(x => !this.onContract || this.hasActiveContract(x));
  }

  public async assetInfomation(row) {
    var ret = await this.UI.openDialog('T4.Service.assetInformationDialog', {
      data: row,
      width: "1600px"
    });
  }

  public ImportTracker() {
    this.showImportTracker = true;
  }

  public beginUpload() {
    this.txtFile.nativeElement.click();
  }

  public async upload(files: FileList) {
    let me = this;

    //Do not exceed maximum files
    if ((files.length) > this.maxFiles) {
      await this.UI.alert("T4.Settings.ServiceGuyDialog.ReachedMaximumLimit", "Maximum limit reached", "T4.Settings.UploadObjectDialog.msgReachedMaximumLimit", "You can only upload a maximum of {0} files at one time.", null, [this.maxFiles]);
      return;
    }

    for (var i = 0; i < files.length; i++) {
      var currentFile = files[i];
      let reader = new FileReader();
      reader.readAsDataURL(currentFile);
      reader.onload = async function () {
        me.loading = true;
        const name = `${currentFile.name.replace(/\.[^/.]+$/, '')}-${new Date().toISOString().replace(/[:.]/g, '-')}${currentFile.name.match(/\.[^/.]+$/)?.[0] || ''}`;
        await me.Api.post<any>("Service/ImportTrackers", "\"" + reader.result.toString() + "\"", { filename: name, mimeType: currentFile.type });
        me.files.push(name);
        me.loading = false;
        me.showImportTracker = false;
        await me.GetAssets();
        await me.UI.alert("T4.Settings.ServiceGuyDialog.ImportProcessed", "Success", "T4.Settings.ServiceGuyDialog.msgImportProcessed", "The trackers are successfully imported to T4");
      };
      reader.onerror = function (error) {
        console.log('Error: ', error);
        me.showImportTracker = false;
        me.UI.alert("T4.Settings.ServiceGuyDialog.ImportProcessedFailed", "Failed", "T4.Settings.ServiceGuyDialog.msgImportProcessesFailed", "Import trackers failed. Please try again later.");
      };
    }
    this.txtFile.nativeElement.value = '';

  }
}

